<!-- part1学习潜力 -->
<template>
	<div class="page_part1">
		<div class="page_shadow page_main">
			<div class="top_header">
				学习力测评报告
			</div>
			<h5 class="header page_header">
				<span>Part{{partIndex}} 学习潜力</span>
			</h5>
			<div class="header_detail_box">
				<p class="header_detail">学习潜力由进行学习活动时所运用到的能力所构成。学习力测评通过对与学习活动相关的9项基本能力进行测试，并与测评者同龄群体平均水平进行对比来评估测评者的学习潜力。</p>
				<p class="header_detail">9项基本能力包括：信息加工能力、工作记忆能力、逻辑推理能力、思维转换能力、表象能力、空间能力、语言能力、数学能力、注意力。</p>
			</div>
			<p class="part_big_title part_big_title_num">{{partIndex}}.1 学习潜力评估结果</p>
			<div class="circle_box">
				<div class="canvas_box">
					<canvas id="part1_canvas" width="150" height="150"></canvas>
					<div class="box">
						<p class="score">{{norm_total.score | toFixed(2)}}</p>
						<p  v-show="norm_total.percent">超过{{norm_total.percent*100 | toFixed(2)}}%<br/>的同龄人</p>
					</div>
				</div>
				<p class="title">学习潜力水平值</p>
			</div>
			<div class="table_box">
				<table >
                    <thead>
                        <tr>
	                        <th>学习潜力指标</th>
	                        <th>潜能水平值</th>
	                        <th>常模范围</th>
	                        <th>出众百分比</th>
	                        <th width="50">评价</th>
	                        <th width="230">
	                        	<img src="~@/assets/report_imgs/part1_rule.png" alt="">
	                        </th>
                    	</tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in norm_copy">
	                        <td>{{data.name }}</td>
	                        <td>{{data.score | toFixed(2)}}</td>
	                        <td>{{data.lnorm}}~{{data.rnorm}}</td>
	                        <td>{{data.percent*100 | toFixed(2)}}%</td>
	                        <td>{{getGrade(data.grade)}}</td>
	                        <td class="td_line">
	                            <div class="percent_line">
		                         	<div :class="['line_score', getColor(data.grade)]" :style="{ width: data.score + 'px' }" :title="data.score | toFixed(2)"></div>
                                    <div class="lien_norm" :style="{left: data.lnorm + 'px', width: (data.rnorm-data.lnorm) + 'px' }"></div>
	                            </div>
	                        </td>
	                    </tr>
                      </tbody>
                </table>
			</div>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
			<div class="top_header">学习力测评报告</div>
			<p class="part_big_title part_big_title_num">{{partIndex}}.2 学习潜力分析</p>
			<!-- 信息加工能力 -->
			<ThePart1Main :normObj="norm_copy[0]" :comment="comment[norm_copy[0].type].comment" ></ThePart1Main>
			<ThePart1Main :normObj="norm_copy[1]" :comment="comment[norm_copy[1].type].comment" ></ThePart1Main>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
			<div class="top_header">学习力测评报告</div>
			<p class="part_big_title"></p>
			<ThePart1Main :normObj="norm_copy[5]" :comment="comment[norm_copy[5].type].comment" ></ThePart1Main>
			<ThePart1Main :normObj="norm_copy[4]" :comment="comment[norm_copy[4].type].comment" ></ThePart1Main>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
			<div class="top_header">学习力测评报告</div>
			<p class="part_big_title"></p>
			<ThePart1Main :normObj="norm_copy[3]" :comment="comment[norm_copy[3].type].comment" ></ThePart1Main>
			<ThePart1Main :normObj="norm_copy[2]" :comment="comment[norm_copy[2].type].comment" ></ThePart1Main>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
			<div class="top_header">学习力测评报告</div>
			<p class="part_big_title"></p>
			<ThePart1Main :normObj="norm_copy[6]" :comment="comment[norm_copy[6].type].comment" ></ThePart1Main>
			<ThePart1Main :normObj="norm_copy[7]" :comment="comment[norm_copy[7].type].comment" ></ThePart1Main>
			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main" v-if="comment">
			<div class="top_header">学习力测评报告</div>
			<p class="part_big_title"></p>
			<ThePart1Main :normObj="norm_copy[8]" :comment="comment[norm_copy[8].type].comment" ></ThePart1Main>
			<p class="big_page_number"></p>
		</div>
	</div>
</template>
<script>
import ThePart1Main from './ThePart1Main.vue';//目录
export default {
	name: 'page_part1',
	components: { ThePart1Main },
    props: {
    	norm: {
	      type: Array//norm数组的其中一项
	      // required: true
	    },
	    comment: {
	   		type: Object//comment的类型解读
	      	// required: true
	    },
	    partIndex: {
	    	type: Number
	    }
    },
    data() {
        return {
        	// comment: null,  //info    work        space    present  think          logic       lang      math
        	// norm: [] //0信息加工能力 1工作记忆能力 2空间能力 3表象能力 4思维转换能力 5逻辑推理能力 6语言能力 7数学能力 
        }
    },
    computed: {
		norm_copy() {
			return this.norm.slice(0,9);
		},
		norm_total() {
			return this.norm[9];
		}
    },
    watch: {
    },
    created() {	
   	
    },
    mounted() {
    	this.setCanvas(this.norm_total.score);
    },
    methods: {
    	getGrade(value) {
    		if(value == 1) {
                return "低";
            }else if(value == 2) {
                return "较低";
            }else if(value == 3) {
                return "中等";
            }else if(value == 4) {
                return "较高";
            }else {
                return "高";
            }
    	},
    	getColor(value) {
    		if(value == 1) {
                return "c_grade1";
            }else if(value == 2) {
                return "c_grade2";
            }else if(value == 3) {
                return "c_grade3";
            }else if(value == 4) {
                return "c_grade4";
            }else {
                return "c_grade5";
            }
    	},
   		setCanvas(score) {
   			let ctx = document.getElementById('part1_canvas').getContext('2d');
   			// 外圈圆
	        ctx.beginPath(); //起始路径，重置当前路径 
	        ctx.strokeStyle = '#F5F5F5'; //设置或返回用于笔触的颜色、渐变或模式。
	        ctx.lineWidth = 10;  //设置或返回当前的线条宽度。
	        ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

	        ctx.arc(75,75,70, 0 * Math.PI, 2*Math.PI); //4个刻度平分180°
	        ctx.stroke()
	        ctx.closePath()


	        //橙色圈
	        ctx.beginPath(); //起始路径，重置当前路径 

	        ctx.strokeStyle = '#41CBAA'; //设置或返回用于笔触的颜色、渐变或模式。
	        ctx.lineWidth = 10;  //设置或返回当前的线条宽度。
	        ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

	        ctx.arc(75,75,70, 1.5 * Math.PI,(score/200*2+1.5)*Math.PI); //4个刻度平分180°
	        ctx.stroke()
	        ctx.closePath()
   		}
    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_part1 {
		.circle_box {
			width: 150px;
			text-align: center;
			margin-bottom: 30px;
			.title {
				line-height: 36px;
				color: #8a8a8a;
			}
		}
		.canvas_box {
			text-align: center;
			position: relative;
			.box {
				position: absolute;
				left: 0;
				top: 30px;
				width: 150px;
				height: 90px;
				font-size: 14px;
				flex-wrap: wrap;
				display: flex;
				align-items: center;
				justify-content: center;
				p {
					width: 100%;
				}
				.score {
					font-size: 20px;
					font-weight: bold;
					color: #F87608;
					line-height: 30px;
				}
			}
		}
		.table_box {
			tr {
				.c_grade1 {
					background-color: #F6B980;
				}
				.c_grade2 {
					background-color: #F08C00;
				}
				.c_grade3 {
					background-color: #E7A53C;
				}
				.c_grade4 {
					background-color: #F87608;
				}
				.c_grade5 {
					background-color: #DF6800;
				}

				th {
					background-color: #41CBAA;
					color: #fff;
					font-size: 16px;
					line-height: 42px;
					background-color: #41CBAA;
					border: 1px solid #fff;
					text-align: center;
				}
				.td_line {
					padding-left: 13px;		
				}
				td {
					font-size: 14px;
					line-height: 46px;
					text-align: center;
					background-color: #F7F7F7;
					border: 1px solid #fff;
					.percent_line {
						width: 200px;
						height: 20px;
						position: relative;
						.lien_norm {
							height: 26px;
							position: absolute;
							top: -3px;
							background-color: rgba(132,60,0,.4);
						}
						.line_score {
							height: 20px;
						}
					}
				}
			}
		}
	}
</style>
